// ink-component
import React, { HTMLAttributes } from 'react';
import styled, { ThemeProvider } from 'styled-components';

import getGlobalProps from '../../helpers/constants/global-props';
import NewFormSectionContent from './components/NewFormSectionContent/NewFormSectionContent';
import NewFormSectionError from './components/NewFormSectionError/NewFormSectionError';
import NewFormSectionSubtitle from './components/NewFormSectionSubtitle/NewFormSectionSubtitle';
import NewFormSectionTitle from './components/NewFormSectionTitle/NewFormSectionTitle';

const NewFormSectionElement = styled.fieldset`
  &:not(:first-child) {
    margin-top: 30px;
  }
`;

export interface NewFormSectionProps extends HTMLAttributes<HTMLFieldSetElement> {
  /** Has section level errors */
  invalid?: boolean;
}

const globalProps = getGlobalProps({});

/**
 * @purpose Breaks forms down into small sections that are easier to understand
 * @group NewFormSection
 * @position 1
 * @categories form
 * @aka formsection
 * @HTMLType HTMLFieldSetElement
 */
function NewFormSection(props: NewFormSectionProps) {
  const { invalid, children, className, style, ...otherProps } = props;

  return (
    <ThemeProvider
      theme={currentTheme => ({
        ...currentTheme,
        formSectionInvalid: invalid,
      })}
    >
      <NewFormSectionElement {...otherProps} {...globalProps}>
        {children}
      </NewFormSectionElement>
    </ThemeProvider>
  );
}

NewFormSection.defaultProps = {
  invalid: false,
};

NewFormSection.Content = NewFormSectionContent;
NewFormSection.Error = NewFormSectionError;
NewFormSection.Subtitle = NewFormSectionSubtitle;
NewFormSection.Title = NewFormSectionTitle;

NewFormSection.displayName = 'NewFormSection';

export { NewFormSectionSubtitleProps } from './components/NewFormSectionSubtitle/NewFormSectionSubtitle';
export { NewFormSectionTitleProps } from './components/NewFormSectionTitle/NewFormSectionTitle';

export default NewFormSection;
